import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

const initData = {
	raw_material_id: '',
	quantity: '',
	unit_id: '',
	price_per_unit: '',
	supplier_name: '',
	comment: '',
};

function AcceptanceMaterials({ modal, setModal, getData }) {
	const { t } = useTranslation();

	const [sendData, setSendData] = useState({ ...initData })

	const [rawMaterials, setRawMaterials] = useState([])
	// const [units, setUnits] = useState([])

	async function create() {
		var sendDataCopy = { ...sendData }
		delete sendDataCopy.unit_id;
		const response = await POST('/inventory/receive-raw/', sendDataCopy)
		if (httpOk(response)) {
			setModal(false);
			setSendData({ ...initData });
			getData();
		}
	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}


	useEffect(() => {
		async function getRawMaterials() {
			const response = await GET('/catalogs/raw-materials/?warehouse_type=raw')
			if (httpOk(response)) {
				setRawMaterials(response.data)
			}
		}

		// async function getUnits() {
		// 	const response = await GET('/catalogs/units/')
		// 	if (httpOk(response)) {
		// 		setUnits(response.data)
		// 	}
		// }

		getRawMaterials()
		// getUnits()
	}, []);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('raw_material_receipt')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('add_receipt_info_desc')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('raw_material')}</label>
						<CustomSelect
							options={rawMaterials}
							value={rawMaterials?.find(option => option.id === sendData?.raw_material_id) || ''}
							onChange={(option) => setSendData({ ...sendData, raw_material_id: option.id, unit_id: option.unit_id })}
							placeholder={t('select_raw_material')}
						/>
					</div>
					<div className="form-group">
						<label>{t('quantity')}</label>
						<input type="text" placeholder='0' name="quantity"
							value={sendData.quantity} onChange={(e) => handleChange(e)} />
					</div>

					{/* <div className="grid2 gap-16">
						<div className="form-group">
							<label>{t('quantity')}</label>
							<input type="text" placeholder='0' name="quantity"
								value={sendData.quantity} onChange={(e) => handleChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('unit_of_measurement')}</label>
							<CustomSelect
								options={units}
								value={units?.find(option => option.id === sendData?.unit_id) || ''}
								onChange={(option) => setSendData({ ...sendData, unit_id: option.id })}
								placeholder={t('unit_short')}
							/>
						</div>
					</div> */}
					<div className="form-group">
						<label>{t('unit_cost')}</label>
						<input type="text" placeholder='0.00' name="price_per_unit"
							value={sendData.price_per_unit} onChange={(e) => handleChange(e)} />
					</div>
					<div className="form-group">
						<label>{t('supplier')}</label>
						<input type="text" placeholder={t('supplier_name')} name="supplier_name"
							value={sendData.supplier_name} onChange={(e) => handleChange(e)} />
					</div>
					<div className="form-group">
						<label>{t('comment')}</label>
						<input type="text" placeholder={t('comment')} name="comment"
							value={sendData.comment} onChange={(e) => handleChange(e)} />
					</div>

				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={() => create()}>
						{t('save')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default AcceptanceMaterials